attachEvent('.files-list__filters-open', 'click', (ev) => {
  ev.target.closest('.sc-files-list').querySelector('.files-list__filters').classList.add('is-open');
  toggleBodyScrollLock(true);
});

attachEvent('.files-list__filters-close, .files-list__filter', 'click', (ev) => {
  ev.target.closest('.files-list__filters').classList.remove('is-open');
  toggleBodyScrollLock(false);
});
